"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PureOfferCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _labeling = _interopRequireDefault(require("../../containers/labeling"));
var _SubscriptionIcon = _interopRequireDefault(require("../SubscriptionIcon"));
var _SkeletonWrapper = _interopRequireDefault(require("../SkeletonWrapper"));
var _reactRedux = require("react-redux");
var _formatNumber = _interopRequireDefault(require("../../util/formatNumber"));
var _planHelper = require("../../util/planHelper");
var _calculateGrossPriceForFreeOffer = _interopRequireDefault(require("../../util/calculateGrossPriceForFreeOffer"));
var _OfferCheckoutCard = _interopRequireDefault(require("./OfferCheckoutCard.utils"));
var _OfferCheckoutCardStyled = require("./OfferCheckoutCardStyled");
var _Price = _interopRequireDefault(require("../Price"));
var OfferCheckoutCard = function OfferCheckoutCard(_ref) {
  var isDataLoaded = _ref.isDataLoaded,
    t = _ref.t;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.offer.offer;
    }),
    title = _useSelector.offerTitle,
    isTrialAvailable = _useSelector.trialAvailable,
    period = _useSelector.period,
    offerId = _useSelector.offerId,
    freePeriods = _useSelector.freePeriods,
    freeDays = _useSelector.freeDays,
    expiresAt = _useSelector.expiresAt,
    startTime = _useSelector.startTime,
    customerPriceInclTax = _useSelector.customerPriceInclTax;
  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
      return state.order.order;
    }),
    offerPrice = _useSelector2.priceBreakdown.offerPrice,
    taxRate = _useSelector2.taxRate,
    country = _useSelector2.country,
    currency = _useSelector2.currency,
    totalPrice = _useSelector2.totalPrice,
    discount = _useSelector2.discount;
  var offerType = offerId === null || offerId === void 0 ? void 0 : offerId.charAt(0);
  var currencySymbol = _planHelper.currencyFormat[currency];
  var isOfferFree = isTrialAvailable || discount.applied && totalPrice === 0;
  var grossPrice = isOfferFree ? (0, _calculateGrossPriceForFreeOffer.default)(offerPrice, taxRate, customerPriceInclTax) : (0, _formatNumber.default)(totalPrice);
  var generateTrialDescription = function generateTrialDescription() {
    if (period === 'season') {
      var _formattedDescription = "You will be charged {{currencySymbol}}{{grossPrice}} (plus applicable taxes) and will be renewed on the next season start date.";
      return t("subscription-desc.period-season", _formattedDescription, {
        currencySymbol: currencySymbol,
        grossPrice: grossPrice
      });
    }
    var taxCopy = country === 'US' ? 'Tax' : 'VAT';
    if (freeDays) {
      var description = "You will be charged {{currencySymbol}}{{grossPrice}} (incl. {{taxCopy}}) after {{freeDays}} days. </br> Next payments will occur every ".concat((0, _OfferCheckoutCard.default)(period));
      return t("subscription-desc.trial-days.period-".concat(period), description, {
        currencySymbol: currencySymbol,
        grossPrice: grossPrice,
        taxCopy: taxCopy,
        freeDays: freeDays
      });
    }

    // freePeriods
    var formattedDescription = 'You will be charged {{currencySymbol}}{{grossPrice}} (incl. {{taxCopy}}) ';
    if (period === 'month') {
      formattedDescription += freePeriods === 1 ? 'after month. </br>Next payments will occur every month.' : 'after {{freePeriods}} months. </br>Next payments will occur every month.';
    } else if (period === 'week') {
      formattedDescription += freePeriods === 1 ? 'after week. </br>Next payments will occur every week.' : 'after {{freePeriods}} weeks. </br>Next payments will occur every week.';
    }
    return t("subscription-desc.trial-period".concat(freePeriods === 1 ? '' : 's', ".period-").concat(period), formattedDescription, {
      currencySymbol: currencySymbol,
      grossPrice: grossPrice,
      taxCopy: taxCopy,
      freePeriods: freePeriods
    });
  };
  var generateSubscriptionDescription = function generateSubscriptionDescription() {
    var taxCopy = country === 'US' ? 'Tax' : 'VAT';
    if (!isTrialAvailable) {
      if (period === 'season') {
        var _formattedDescription2 = "You will be charged {{currencySymbol}}{{grossPrice}} (plus applicable taxes) and will be renewed on the next season start date.";
        return t("subscription-desc.period-season", _formattedDescription2, {
          currencySymbol: currencySymbol,
          grossPrice: grossPrice
        });
      }
      var formattedDescription = "You will be charged {{currencySymbol}}{{grossPrice}} (incl. {{taxCopy}}) every ".concat((0, _OfferCheckoutCard.default)(period));
      return t("subscription-desc.period-".concat(period), formattedDescription, {
        currencySymbol: currencySymbol,
        grossPrice: grossPrice,
        taxCopy: taxCopy
      });
    }
    return generateTrialDescription();
  };
  var renderDescription = function renderDescription() {
    if (offerType === 'S') {
      return generateSubscriptionDescription();
    }
    if (offerType === 'P') {
      if (!period) {
        var date = (0, _planHelper.dateFormat)(expiresAt, true);
        return t('pass-desc.date', "Access until {{date}}", {
          date: date
        });
      }
      return _planHelper.periodMapper[period] ? "".concat(_planHelper.periodMapper[period].accessText, " season pass") : '';
    }
    if (offerType === 'E') {
      return "Pay-per-view event ".concat(startTime ? (0, _planHelper.dateFormat)(startTime, true) : '');
    }
    if (offerType === 'R') {
      return _planHelper.periodMapper[period] ? "".concat(_planHelper.periodMapper[period].accessText, " access") : '';
    }
    if (offerType === 'A') {
      return t('Unlimited access');
    }
    return '';
  };
  var renderTrialBadgeDescription = function renderTrialBadgeDescription() {
    if (freeDays) {
      return t('trial-badge-days', "{{freeDays}} days free trial", {
        freeDays: freeDays
      });
    }
    if (freePeriods === 1) {
      return t("trial-badge.period-".concat(period), "1 {{period}} free trial", {
        period: period
      });
    }
    return t("trial-badge.periods-".concat(period), "{{freePeriods}} {{period}}s free trial", {
      freePeriods: freePeriods,
      period: period
    });
  };
  return /*#__PURE__*/_react.default.createElement(_OfferCheckoutCardStyled.WrapperStyled, null, /*#__PURE__*/_react.default.createElement(_SkeletonWrapper.default, {
    showChildren: isDataLoaded,
    width: 50,
    height: 50
  }, /*#__PURE__*/_react.default.createElement(_SubscriptionIcon.default, {
    period: period || offerType
  })), /*#__PURE__*/_react.default.createElement(_OfferCheckoutCardStyled.InnerWrapper, null, /*#__PURE__*/_react.default.createElement(_SkeletonWrapper.default, {
    showChildren: isDataLoaded,
    width: 200,
    margin: "0 0 10px 10px"
  }, /*#__PURE__*/_react.default.createElement(_OfferCheckoutCardStyled.TitleStyled, null, t("offer-title-".concat(offerId), title))), /*#__PURE__*/_react.default.createElement(_SkeletonWrapper.default, {
    showChildren: isDataLoaded,
    width: 300,
    margin: "0 0 10px 10px"
  }, /*#__PURE__*/_react.default.createElement(_OfferCheckoutCardStyled.DescriptionStyled, {
    dangerouslySetInnerHTML: {
      __html: renderDescription()
    }
  }))), /*#__PURE__*/_react.default.createElement(_OfferCheckoutCardStyled.PriceWrapperStyled, null, /*#__PURE__*/_react.default.createElement(_SkeletonWrapper.default, {
    showChildren: isDataLoaded,
    width: 80,
    height: 30
  }, isTrialAvailable && /*#__PURE__*/_react.default.createElement(_OfferCheckoutCardStyled.TrialBadgeStyled, null, renderTrialBadgeDescription()), /*#__PURE__*/_react.default.createElement(_Price.default, {
    currency: _planHelper.currencyFormat[currency],
    price: Number(grossPrice),
    period: offerType === 'S' && period !== 'season' ? t("offer-price.period-".concat(period), period) : null
  }))));
};
exports.PureOfferCard = OfferCheckoutCard;
OfferCheckoutCard.propTypes = {
  isDataLoaded: _propTypes.default.bool,
  t: _propTypes.default.func
};
OfferCheckoutCard.defaultProps = {
  isDataLoaded: true,
  t: function t(k) {
    return k;
  }
};
var _default = (0, _reactI18next.withTranslation)()((0, _labeling.default)()(OfferCheckoutCard));
exports.default = _default;